import React from "react";
import { Search } from "../Search";

interface PatientsSearchProps {
  searchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PatientsSearch: React.FC<PatientsSearchProps> = ({
  searchTerm,
  onSearchChange,
}) => {
  return (
    <Search
      placeholder="Search"
      value={searchTerm}
      onChange={onSearchChange}
      width="366px"
    />
  );
};

export default React.memo(PatientsSearch);
